const en = {
  table: {
    actions: "Actions",
  },
  errors: {
    requiredFieldsEmpty: "Check empty required fields",
    fieldRequired: "Field is required",
  },
  done: "Done",
  print: "Print",
  login: "Log in",
  username: "User",
  password: "Password",
  customFields: "Custom Fields",
  variables: "Variables",
  edit: "Edit",
  general: "General",
  delete: "Delete",
  save: "Save",
  confirm: "Confirm",
  warning: "Warning",
  cancel: "Cancel",
  hours: "Hours",
  minutes: "Minutes",
  logout: "Log out",
  options: "Options",
  height: "Height",
  titleModalConfigFields: "Field Settings",
  titleModalConfigFieldsColumnOne: "Job Fields",
  titleModalConfigFieldsColumnTwo: "Selected Record Type Fields",
  dayOfWeek: {
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Fourth",
    thursday: "Fifth",
    friday: "Friday",
    saturday: "Sabado",
  },
  analyzeInput: { title: "Analyzes", group: "Group | Groups" },
  components: {
    basicHistory: {
      createAt: "Included in",
      createBy: "by",
    },
    regEdit: {
      filters: {
        jobCode: "Job Code",
        resourceCode: "Resource Code",
        regTypeCode: "Reg Type Code",
        user: "User Name",
        dtStart: "Date Start",
        dtEnd: "Date End",
        searchEdit: "Search",
      },
      headers: {
        date: "Date",
        job: "Code Job",
        resource: "Resource",
        user: "User",
        regType: "Registration Type",
        description: "Description",
        codAccount: "Code Account",
        desAccount: "Description Account",
        codItem: "Code Item",
        descItem: "Description Item",
      },
      fields: {
        fieldTitle: "Fields",
        fieldDelete: "Delete",
        fieldSubtitle: "Field",
        valueSubtitle: "Value",
        noFields: "No Fields",
      },
    },
  },
  entities: {
    reg: {
      title: "Registry | Registries",
      production: "Production",
      props: {
        date: "Date | Date Retroactive"
      }
    },
    actionField: {
      title: "Action Field | Action Fields",
      comboValue: "Value",
      props: {
        label: "Label",
        dataType: "Data Type",
        isRequired: "Required",
        combo: "Combo",

      },
    },
    action: {
      title: "Action | Actions",
      props: {
        code: "Code",
        description: "Description",
        group: "Group",
        path: "Path",
        type: "Type",
        entity: "Entity",
        response: "Response",
        fields: "Fields"
      },
    },
    job: {
      title: "Job | Jobs",
      solic: "Job Solicitation",
      props: {
        code: "Code",
        group: "Job Group?",
        description: "Description",
        status: "Status",
        date: "Date",
        environmentId: "Environment",
        item: "Item",
        qt: "Quantity",
        version: "Version",
        accountId: "Account",
        deadline: "Deadline",
        notes: "Note"
      },
      forms: {
        create: {
          title: "Create Job",
        },
      },
    },
    jobStageItemCons: {
      title: "Item | Items",
      props: {
        itemId: "Registered Item",
        itemDescription: "Item Description",
        unitId: "Unit",
        qtEstimated: "Estimated Qty",
        qtReal: "Actual Qty",
      },
    },
    jobStageItemProd: {
      title: "Item | Items",
      props: {
        itemId: "Registered Item",
        itemDescription: "Item Description",
        unitId: "Unit",
        qtEstimated: "Estimated Qty",
        qtReal: "Actual Qty",
      },
    },
    printer: {
      title: "Printer | Printers",
      props: {
        code: "Code",
        description: "Description",
        path: "Path",
        printAgentPath: "Print Agent Path",
      },
    },
    jobStage: {
      title: "Jog Stage | Job Stages",
      tabs: {
        form: {
          jobStageItemsProd: "Items Prod",
          jobStageItemsCons: "Items Cons",
        },
      },
      props: {
        status: "Status",
        order: 'Order',
        description: "Description",
        timeSetupEstimatedMin: "Estimated Setup (Min)",
        timeSetupRealMin: "Setup Real (Min)",
        timeProdEstimatedMin: "Estimated Production (Min)",
        timeProdRealMin: "Actual Production (Min)",
        qtLossEstimated: "Estimated Loss Qty",
        qtLossReal: "Actual Loss Qty",
        percLoss: "% Estimated Loss",
        resourceId: "Resource",
        stageTypeId: "Type Stage",
        versionId: "Version",
        itemId: "Item",
        subStage: "SubStage",
      },
    },
    stageType: {
      title: "Type Stage | Types Stage",
      tabs: {
        form: {
          regTypes: "Registration Types",
        },
      },
      props: {
        description: "Description",
        environmentId: "Environment",

        name: "Name",
      },
    },
    user: {
      title: "User | Users",
      props: {
        code: "Code",
        name: "Name",
      },
    },
    report: {
      title: "Report | Reports",
      props: {
        query: "Query",
        font: "Font",
        params: "Param | Params",
        description: "Description",
      },
    },
    resource: {
      title: "Resource | Resources",
      props: {
        code: "Code",
        seq: "Seq",
        environmentId: "Environment",
        stageTypeId: "Stage Type",
        printerId: "Printer",
        description: "Description",
        resourceRestIds: "Compatible Feature",
        sector: "Sector",
        type: "Type",
      },
    },
    entityFieldCustom: {
      title: 'Custom Field | Custom Fields',
      props: {
        entity: 'Entity',
        type: 'Type',
        group: 'Group',
        label: 'Label',
        seq: "Seq"
      }
    },
    account: {
      title: "Account | Accounts",
      props: {
        code: "Code",
        name: "Name",
      },
    },
    regTypeFields: {
      title: "Registration Field | Registration Fields",
      props: {
        label: "Field",
        seq: "Seq",
        typeData: "Type Data",
        parameterItemId: "Parameter Item",
        behavior: "Behavior",
        length: "Length",
        required: "Required",
        optionLabel: "Option",
        readOnly: "Read Only",
        variableKey: "Variable Key",
        readType: "Read Type"
      },
    },
    regType: {
      title: "Type of Registration | Registration Types",

      props: {
        code: "Code",
        continuous: "Continuous",
        keepFieldIds: "Keep Fields",
        description: "Description",
        color: "Color",
        stageRequired: "Requires Stage",
        allowRetroactive: "Allow Retroactive",
        retroactiveLimitDays: "Retroactive Limit Days",
        environmentId: "Environment",
        jobStatusId: "Switch to Job Status",
        jobStageStatusId: "Switch to Job Stage Status",
        reportId: "Report",
        printerId: "Printer",
        timeType: 'Time',
        trigger: {
          title: 'Trigger | Triggers',
          props: {
            confirm: 'Confirm',
            beforeSend: 'Before Send',
            afterSend: 'After Send'
          }
        }
      },
    },

    regEdit: {
      title: "Registration Consultation | Registration Consultation",
    },
    environment: {
      filter: "Sector",
      title: "Environment | Environments",
      calendarExc: {
        title: "Exc Calendar",
        props: {
          date: "Data",
          start: "Start Time",
          end: "Final hour",
        },
      },
      calendarProd: {
        title: "Prod Calendar",
        props: {
          dayOfWeek: "Day of the week",
          start: "Start Time",
          end: "Final hour",
        },
      },
      jobStageStatus: {
        title: "Job Stage Status",
        props: {
          status: "Status",
          seq: "Seq",
          description: "Description",
          color: "Color",
          statusNext: "Next Status",
          type: "Type",
        },
      },
      jobStatus: {
        title: "Job Status",
        props: {
          status: "Status",
          seq: "Seq",
          description: "Description",
          color: "Color",
          statusNext: "Next Status",
          leadTimeMin: "Lead Time (min)",
        },
      },
      tabs: {
        form: {
          jobStatus: "Job Status",
          jobStageStatus: "Job Stage Status",
          calendarProd: "Prod Calendar",
          calendarExc: "Exc Calendar",
        },
      },
      props: {
        code: "Code",
        description: "Description",
      },
    },
    stageItem: {
      title: "Item | Items",
      itemDatabase: "Registered Item",
      props: {
        itemId: "Item",
        itemDescription: "Item Description",
        unitId: "Unit",
        qt: "Amount",
        qtMin: "Amount Min",
        qtMax: "Amount Max",
        qtIdeal: "Amount ideal",
      },
    },
    stage: {
      title: "Stage | Stages",
      tabs: {
        form: {
          stageItemsProd: "Prod Items",
          stageItemsCons: "Cons Items",
        },
      },
      props: {
        description: "Description",
        seq: "Sequence",
        timeSetupEstimatedMin: "Estimated Setup (Min)",
        timeProdEstimatedMin: "Estimated Production (Min)",
        percLoss: "% Estimated Loss",
        resourceId: "Resource",
        stageTypeId: "Type Stage",
        versionId: "Version",
        itemId: "Item",
        subStage: "SubStage",
      },
    },
    version: {
      title: "Version | Versions",
      tabs: {
        form: {
          stages: "Stages",
        },
      },
      props: {
        code: "Code",
        description: "Description",
        unit: "unity",
      },
    },
    item: {
      title: "Item | Items",
      props: {
        code: "Code",
        environmentId: "Environment",
        description: "Description",
        unit: "unity",
        type: "Type",
      },
    },
    unit: {
      title: "Unit | Units",
      props: {
        code: "Code",
        description: "Description",
        type: "Type",
      },
    },
  },
};

export default en;
